import React from 'react'

const Footer = (props) => {

    return (
        <footer id="footer" className="footer navbar-fixed-bottom">

            <div className="disclaimer container-fluid text-center">
                {
                    props.health ?
                        "Este site é destinado exclusivamente para visualização do portifólio. É estritamente proibido compartilhar qualquer parte com terceiros sem prévia autorização."
                        :
                        props.tale ?
                            "Copyright © 2020 | Natália Ritzmann"
                            :
                            "Este site é destinado exclusivamente para a visualização do portifólio. É proibida a reprodução e utilização destes textos em outros veículos."
                }
            </div>
            <div className="position-static inner d-flex justify-content-center">
                <ul className="copyright text-center">
                    <li>
                        &copy;
                    </li>
                    <li>Templated by <a href="https://html5up.net">HTML5 UP</a></li>
                    <li>Designed by <a href="https://www.linkedin.com/in/tainafabro">Tainá Fabro</a></li>
                    <li>Coded by <a href="https://vyk1.github.io">Victoria Botelho Martins</a></li>
                </ul>

            </div>
        </footer>
    )
}
Footer.defaultProps = {
    disclaimer: false,
    tale: false,
    health: false
}

export default Footer
